import { useState } from 'react';

export default function PlumbingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How do I know if I need a licensed plumber or if it\'s a DIY job?',
      answer: 'Licensed plumbers are required for any work involving water supply lines, drain lines, gas lines, or modifications to existing plumbing systems. DIY is only appropriate for simple tasks like replacing faucet aerators or unclogging drains with a plunger. For anything involving pipes, water heaters, or sewer lines, always hire a licensed professional to ensure safety and code compliance.'
    },
    {
      question: 'What should I expect to pay for common plumbing services in El Paso?',
      answer: 'Plumbing costs vary by project complexity. Basic drain cleaning typically runs $150-$300, faucet installation $150-$400, water heater installation $800-$2,500, and whole-house repiping $4,000-$15,000. Emergency services and after-hours calls usually include premium rates. Always get multiple written estimates and verify what\'s included in the quoted price.'
    },
    {
      question: 'How quickly can a plumber respond to an emergency in El Paso?',
      answer: 'Most El Paso plumbing companies offering 24/7 emergency service can respond within 1-2 hours for urgent issues like burst pipes, major leaks, or sewage backups. Response times may vary based on location, time of day, and current demand. It\'s wise to have a trusted plumber\'s contact information saved before an emergency occurs.'
    },
    {
      question: 'Do I need a permit for plumbing work in El Paso?',
      answer: 'Yes, most plumbing work in El Paso requires permits, including water heater replacement, repiping, new fixture installations, and any work involving water supply or drain lines. Your licensed plumber should handle permit applications and ensure all work meets local building codes. Unpermitted work can cause issues when selling your home and may void insurance coverage.'
    },
    {
      question: 'How often should I have my plumbing system inspected?',
      answer: 'Annual plumbing inspections are recommended for homes over 10 years old or if you have hard water issues common in El Paso. Inspections should include checking for leaks, testing water pressure, inspecting water heater condition, and examining exposed pipes. Regular maintenance can prevent costly emergency repairs and extend the life of your plumbing system.'
    },
    {
      question: 'What causes low water pressure in El Paso homes?',
      answer: 'Low water pressure in El Paso is often caused by mineral buildup from hard water, corroded pipes in older homes, leaks in the system, or issues with the main water line. A plumber can diagnose the cause through pressure testing and inspection. Solutions may include installing a water softener, replacing corroded pipes, or repairing leaks.'
    },
    {
      question: 'Should I repair or replace my water heater?',
      answer: 'If your water heater is over 10 years old, requires frequent repairs, or shows signs of rust or leaks, replacement is usually more cost-effective. Modern tankless or high-efficiency models can significantly reduce energy costs. For newer units with minor issues, repair may be appropriate. A licensed plumber can assess your specific situation and provide recommendations.'
    },
    {
      question: 'How can I prevent frozen pipes during El Paso winters?',
      answer: 'While El Paso winters are mild, occasional freezes can occur. Protect pipes by insulating exposed pipes in attics, crawl spaces, and exterior walls. During freezing weather, let faucets drip slightly, keep cabinet doors open under sinks, and maintain consistent indoor temperatures. If pipes do freeze, never use open flames to thaw them—call a plumber immediately.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about plumbing services, contractors, and projects in El Paso.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:border-blue-500 transition-all">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-8">{faq.question}</h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-blue-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
